import Joi from 'joi-full';
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose, withHandlers, withProps, withState } from 'recompose';
import getOr from 'lodash/fp/getOr';
import { uniqBy } from 'lodash';

import StaffForm from './StaffForm';
import { syncValidateData } from '../../../common/validator';
import { getShopBrandId, getShops, isBrandViewActive } from '../../../auth/selectors';
import { t } from '../../../../modules/infra/i18n';

export const STAFF_FORM = 'staffForm';
const selector = formValueSelector(STAFF_FORM);

// Store translation key instead of calling t() at module level
const USERNAME_LABEL_KEY = 'barber:staff.form.validation.username_label';

// Create schema function that runs at validation time
const createSchema = () => Joi.object().keys({
  username: Joi.string().required().min(3).max(50)
    .label(t(USERNAME_LABEL_KEY)),
  kind: Joi.string().allow('2', '5'),
  shopIds: Joi.array()
    .when('kind', { is: '2', then: Joi.required(), otherwise: Joi.allow('', null, []) })
    .optional(),
});

const validate = values => syncValidateData(values, createSchema());

const enhance = compose(
  connect(state => ({
    isBrandView: isBrandViewActive(state),
    userShops: getShops(state),
    brandId: getShopBrandId(state),
  })),
  reduxForm({
    form: STAFF_FORM,
    validate,
    enableReinitialize: true,
  }),
  connect(state => ({
    userKind: selector(state, 'kind'),
  })),
  withState(
    'shops',
    'setShops',
      props => uniqBy([...props.userShops, ...getOr([], 'staffUser.shops', props)], 'id'),
  ),
  withProps(props => ({
    canModifyUsername: props.canModifyStaff && !props.isEditingAccountOwner,
    // eslint-disable-next-line max-len
    canModifyUserKind: props.canModifyStaff && !props.isEditingAccountOwner && !props.isEditingSelf && props.isBrandView,
    canAssignShops: props.canModifyStaff && !props.isEditingAccountOwner && !props.isEditingSelf,
    canModifyPermissions: props.canModifyStaff && !props.isEditingAccountOwner && !props.isEditingSelf,
    canDelete: props.edit && props.canModifyStaff && !props.isEditingSelf,
    canSave: props.canModifyStaff,
  })),
  withHandlers({
    onCancel: props => () => {
      props.goToUrl(props.baseUrl);
    },
  }),
);

export default enhance(StaffForm);
